const RegisterForm = ({
  handleSubmit,
  name,
  setName,
  email,
  setEmail,
  password,
  setPassword,
}) => (
  <form onSubmit={handleSubmit} className="mt-4">
    <div className="modal-content rounded-4 shadow">
      <div className="modal-header p-5 pb-4 border-bottom-0">
        <h2 className="fw-bold mb-0">Sign up</h2>
      </div>
      <div className="p-5 pt-0">
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="Enter name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <label htmlFor="floatingInput">Enter name</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <label htmlFor="floatingInput">Enter email</label>
          </div>
          <div className="form-floating mb-3">
            <input
              type="password"
              className="form-control"
              placeholder="Enter password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>
          <button disabled={!name || !email || !password} className="w-100 mb-2 btn btn-lg rounded-3 btn-dark">
            Continue
          </button>
          <small className="text-muted">
            By clicking Sign up, you agree to the terms of use.
          </small>
          <hr className="my-4" />
          <h2 className="fs-5 fw-bold mb-3">Or use a third-party</h2>
          <button
            className="w-100 py-2 mb-2 btn btn-outline-info rounded-3"
            type="submit"
          >
            <svg className="bi me-1" width={16} height={16}>
              <use xlinkHref="#twitter" />
            </svg>
            Sign up with Twitter
          </button>
          <button
            className="w-100 py-2 mb-2 btn btn-outline-primary rounded-3"
            type="submit"
          >
            <svg className="bi me-1" width={16} height={16}>
              <use xlinkHref="#facebook" />
            </svg>
            Sign up with Facebook
          </button>
          <button
            className="w-100 py-2 mb-2 btn btn-outline-secondary rounded-3"
            type="submit"
          >
            <svg className="bi me-1" width={16} height={16}>
              <use xlinkHref="#github" />
            </svg>
            Sign up with Apple
          </button>
      </div>
    </div>
  </form>
);

export default RegisterForm;
